import { Routes } from '@angular/router';
import { LandingLayoutComponent } from './layout/landing-layout/landing-layout.component';
import { RegisterComponent } from './feature/register/register.component';
import { LoginProfileComponent } from './feature/login-profile/login-profile.component';
import { ChooseCompanyComponent } from './feature/choose-company/choose-company.component';
import { companyGuard } from './core/guard/company.guard';
import { authGuardFn } from '@auth0/auth0-angular';
import { AuthCallbackComponent } from './feature/auth-callback/auth-callback.component';
import { CheckEmailComponent } from './layout/auth-layout/check-email.component';
import { SuccessNewUserComponent } from './layout/auth-layout/success-new-user.component';
import { SuccessVerifyEmailComponent } from './layout/auth-layout/success-verify-email.component';
import { LinkAccountLayoutComponent } from './layout/auth-layout/link-account-layout.component';
import { NotFoundComponent } from './layout/landing-layout/not-found.component';
import { LoginWithSocialComponent } from './layout/auth-layout/login-with-social.component';
import { actionLinkAccountGuard } from './core/guard/action-link-account.guard';
import { MissingPermissionPageComponent } from './ui/missing-permission-page/missing-permission-page.component';
import { LandingOrganizationInactiveComponent } from './layout/landing-layout/landing-organization-inactive/landing-organization-inactive.component';
import { businessInactiveGuard } from './core/guard/business-inactive.guard';

export enum ROUTER_TOKENS {
  APP = 'app',
  BIZ = 'biz',
  COMP = 'comp',
  REGISTER = 'register',
  LOGIN_PROFILE = 'login-profile',
  CHOOSE_COMPANY = 'choose-company',
  USER_PROFILE = 'user-profile',
  SIGN_OUT = 'sign-out',
  HOME = 'home',
  DASHBOARD = 'dashboard',
  COMPANY = 'company',
  USER = 'user',
  SETTING = 'setting',
  CONNECT = 'connect',
  CONTACT = 'contact',
  BROADCAST = 'broadcast',
  CHAT_MANAGE = 'chat-manage',
  TEMPLATE_REPLY = 'template-reply',
  TEAM = 'team',
  AGENT = 'agent',
  CHATBOT = 'chatbot',
  CHATBOT_MANAGEMENT = 'chatbot-management',
  CHATBOT_KEYWORD = 'chatbot-keyword',
  DELIVERY = 'delivery',
  SHOP_MANAGEMENT = 'shop-management', // DELIVERY
  ORDER = 'order', // DELIVERY
  GLOBAL_CONFIG = 'global-config', // DELIVERY
  PRODUCT_GROUP = 'product-group', // DELIVERY
  USER_MANAGEMENT = 'user-management',
  ROLE_PERMISSION = 'role-permission',
  CONTACT_MANAGEMENT = 'contact-management',
  CONTACT_TAGS = 'contact-tags',
  AUTH_CALLBACK = 'auth-callback',
  AUTH_CHECK_EMAIL = 'check-email',
  AUTH_SUCCESS_NEW_USER = 'success-new-user',
  AUTH_SUCCESS_VERIFY_EMAIL = 'success-verify-email',
  AUTH_LINK_ACCOUNT = 'link-account',
  AUTH_LOGIN_WITH_SOCIAL = 'not-link-account',
  FILE_MANAGE = 'file-management',
  MISSING_PERMISSION = 'missing-permission',
  CHATBOT_LOG_REPORT = 'chatbot-log-report',
  CHATBOT_LOG_EXPORT = 'chatbot-log-export',
  COMP_SETTING = 'comp-setting',
  ECOMMERCE = 'ecommerce',
  CATEGORY = 'category',
  PRODUCT = 'product',
  INVENTORY = 'inventory',
  CUSTOMER = 'customer',
  PAYMENT = 'payment',
  SHIPMENT = 'shipment',
  COMP_COMMERCE_SETTING = 'comp-commerce-setting',
  SOCIAL = 'social',
  THIRD_PARTY = 'third-party',
  IMPORT_EXPORT = 'import-export',
  DOCUMENT = 'document',
  SORTING = 'sorting',
  IMPORT = 'import',
  CUSTOMER_MANAGEMENT = 'customer-management',
  TEMPLATE_MANAGEMENT = 'template-management',
  ORGANIZATION_INACTIVE = 'organization-inactive',
  MAPPING = 'mapping',
  MCCN = 'mccn',
}

export const routes: Routes = [
  {
    path: '',
    component: LandingLayoutComponent,
  },
  {
    path: ROUTER_TOKENS.AUTH_LINK_ACCOUNT,
    canActivate: [actionLinkAccountGuard],
    component: LinkAccountLayoutComponent,
  },
  {
    path: ROUTER_TOKENS.AUTH_LOGIN_WITH_SOCIAL,
    component: LoginWithSocialComponent,
  },
  {
    path: ROUTER_TOKENS.AUTH_CHECK_EMAIL,
    component: CheckEmailComponent,
  },
  {
    path: ROUTER_TOKENS.AUTH_SUCCESS_VERIFY_EMAIL,
    component: SuccessVerifyEmailComponent,
  },
  {
    path: ROUTER_TOKENS.AUTH_SUCCESS_NEW_USER,
    component: SuccessNewUserComponent,
  },
  {
    path: ROUTER_TOKENS.REGISTER,
    component: RegisterComponent,
  },
  {
    path: ROUTER_TOKENS.AUTH_CALLBACK,
    // canActivate:[callbackLoginGuard],
    canActivate: [],
    component: AuthCallbackComponent,
  },
  {
    path: ROUTER_TOKENS.LOGIN_PROFILE,
    component: LoginProfileComponent,
  },
  {
    path: ROUTER_TOKENS.CHOOSE_COMPANY,
    canActivate: [businessInactiveGuard, companyGuard],
    component: ChooseCompanyComponent,
  },
  {
    path: ROUTER_TOKENS.APP,
    canActivateChild: [authGuardFn],
    loadChildren: () => import('../app/layout/main-layout.routes').then((m) => m.mainLayoutRoutes),
  },
  {
    path: ROUTER_TOKENS.MISSING_PERMISSION,
    component: MissingPermissionPageComponent,
  },
  {
    path: ROUTER_TOKENS.ORGANIZATION_INACTIVE,
    component: LandingOrganizationInactiveComponent,
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];
